export const SET_AUTH_USER   = 'SET_AUTH_USER'
export const UNSET_AUTH_USER = 'UNSET_AUTH_USER'

export const SET_AUTH_EMPLOYEE   = 'SET_AUTH_EMPLOYEE'
export const UNSET_AUTH_EMPLOYEE = 'UNSET_AUTH_EMPLOYEE'

export const LOGIN                  = 'LOGIN'
export const LOGIN_SUCCESS          = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE          = 'LOGIN_FAILURE'
export const EMPLOYEE_LOGIN         = 'EMPLOYEE_LOGIN'
export const EMPLOYEE_LOGOUT        = 'EMPLOYEE_LOGOUT'
export const EMPLOYEE_LOGIN_SUCCESS = 'EMPLOYEE_LOGIN_SUCCESS'
export const EMPLOYEE_LOGIN_FAILURE = 'EMPLOYEE_LOGIN_FAILURE'
export const CLEAR_LOGIN_ERRORS     = 'CLEAR_LOGIN_ERRORS'
export const LOGOUT                 = 'LOGOUT'
export const SET_TOKEN              = 'SET_TOKEN'
export const REFRESH_TOKEN          = 'REFRESH_TOKEN'

export const TOKEN_TIMER       = 'TOKEN_TIMER'
export const START_TOKEN_TIMER = 'START_TOKEN_TIMER'
export const STOP_TOKEN_TIMER  = 'STOP_TOKEN_TIMER'

export const TWO_FACTOR_DISABLE = 'TWO_FACTOR_DISABLE'
export const TWO_FACTOR_ENABLE  = 'TWO_FACTOR_ENABLE'
export const TWO_FACTOR_VERIFY  = 'TWO_FACTOR_VERIFY'

export const SHOW_SUCCESS_NOTIFICATION = 'SHOW_SUCCESS_NOTIFICATION'
export const HIDE_SUCCESS_NOTIFICATION = 'HIDE_SUCCESS_NOTIFICATION'
export const SHOW_ERROR_NOTIFICATION   = 'SHOW_ERROR_NOTIFICATION'
export const HIDE_ERROR_NOTIFICATION   = 'HIDE_ERROR_NOTIFICATION'
export const SHOW_INFO_NOTIFICATION    = 'SHOW_INFO_NOTIFICATION'
export const HIDE_INFO_NOTIFICATION    = 'HIDE_INFO_NOTIFICATION'
export const HIDE_ALL_NOTIFICATION     = 'HIDE_ALL_NOTIFICATION'

export const SET_NO_PERMISSION   = 'SET_NO_PERMISSION'
export const UNSET_NO_PERMISSION = 'UNSET_NO_PERMISSION'

export const IS_LOADING     = 'IS_LOADING'
export const IS_NOT_LOADING = 'IS_NOT_LOADING'

export const SEND_NOTIFICATION = 'SEND_NOTIFICATION'

export const ORDER_CLEAR     = 'ORDER_CLEAR'
export const ORDER_DETAILS   = 'ORDER_DETAILS'
export const ORDER_SITE_NAME = 'ORDER_SITE_NAME'

export const CCDB_CLEAR                = 'CCDB_CLEAR'
export const CCDB_DETAILS              = 'CCDB_DETAILS'
export const CCDB_ORDER_CONTACT_TYPES  = 'CCDB_ORDER_CONTACT_TYPES'
export const CCDB_ORDER_CREATE         = 'CCDB_ORDER_CREATE'
export const CCDB_ORDER_UPDATE         = 'CCDB_ORDER_UPDATE'
export const CCDB_ORDER_DETAILS        = 'CCDB_ORDER_DETAILS'
export const CCDB_ORDER_DELETE         = 'CCDB_ORDER_DELETE'
export const CCDB_CONTACT_METHOD_TYPES = 'CCDB_CONTACT_METHOD_TYPES'

export const CCDB_CONTACT_METHOD_CREATE       = 'CCDB_CONTACT_METHOD_CREATE'
export const CCDB_CONTACT_METHOD_UPDATE       = 'CCDB_CONTACT_METHOD_UPDATE'
export const CCDB_CONTACT_METHOD_DELETE       = 'CCDB_CONTACT_METHOD_DELETE'
export const CCDB_ORDER_CONTACT_METHOD_CREATE = 'CCDB_ORDER_CONTACT_METHOD_CREATE'
export const CCDB_ORDER_CONTACT_METHOD_UPDATE = 'CCDB_ORDER_CONTACT_METHOD_UPDATE'
export const CCDB_ORDER_CONTACT_METHOD_DELETE = 'CCDB_ORDER_CONTACT_METHOD_DELETE'

export const ZONE_UPDATE        = 'ZONE_UPDATE'
export const ZONE_CLEAR         = 'ZONE_CLEAR'
export const ZONE_DETAILS       = 'ZONE_DETAILS'
export const ZONE_FILE          = 'ZONE_FILE'
export const ZONE_RECORD_CREATE = 'ZONE_RECORD_CREATE'
export const ZONE_RECORD_UPDATE = 'ZONE_RECORD_UPDATE'
export const ZONE_RECORD_DELETE = 'ZONE_RECORD_DELETE'
export const ZONE_MASTER_DIG    = 'ZONE_MASTER_DIG'
export const ZONE_MASTER_WHOIS  = 'ZONE_MASTER_WHOIS'
export const ZONE_MASTER_UPDATE = 'ZONE_MASTER_UPDATE'
export const ZONE_MASTER_CREATE = 'ZONE_MASTER_CREATE'
export const ZONE_MASTER_DELETE = 'ZONE_MASTER_DELETE'

export const LOAD_ALL_LOOKUPS           = 'LOAD_ALL_LOOKUPS'
export const LOAD_NOTIFICATION_TYPES    = 'LOAD_NOTIFICATION_TYPES'
export const LOAD_PORT_LAG_INTERFACES   = 'LOAD_PORT_LAG_INTERFACES'
export const LOAD_TICKET_SUPPORT_AREAS  = 'LOAD_TICKET_SUPPORT_AREAS'
export const LOAD_TICKET_INCIDENT_TYPES = 'LOAD_TICKET_INCIDENT_TYPES'
export const LOAD_ZONE_RECORD_TYPES     = 'LOAD_ZONE_RECORD_TYPES'
export const LOAD_ZONE_SOAS             = 'LOAD_ZONE_SOAS'
export const LOAD_ISM_COMMANDS          = 'LOAD_ISM_COMMANDS'
export const LOAD_ISM_SOURCES           = 'LOAD_ISM_SOURCES'

export const ACCOUNTS_CLEAR  = 'ACCOUNTS_CLEAR'
export const ACCOUNTS_LIST   = 'ACCOUNTS_LIST'
export const ACCOUNT_CLEAR   = 'ACCOUNT_CLEAR'
export const ACCOUNT_DETAILS = 'ACCOUNT_DETAILS'
export const ACCOUNT_UPDATE  = 'ACCOUNT_UPDATE'

export const TICKET_CREATE  = 'TICKET_CREATE'
export const TICKET_COMMENT = 'TICKET_COMMENT'

export const JOB_CLEAR   = 'JOB_CLEAR'
export const JOB_DETAILS = 'JOB_DETAILS'

export const REFERENCE_CLEAR   = 'REFERENCE_CLEAR'
export const REFERENCE_DETAILS = 'REFERENCE_DETAILS'